import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { httpConfig } from "./httpConfig";
import Swal from "sweetalert2";
import { showURL } from "./config/studentpicURL";
import { RequestFetch } from "./config/requestFetch";
import Cookies from "universal-cookie";
import { ProtectedLogin } from "./protectedlogin";
import { Addmetatags } from "./config/addmetatags";

const ListStudentHL = () => {
  const cookie = new Cookies();
  const usertoken = cookie.get("tokenEstimate");

  //ทำงานคล้ายกับ wardround_grouplist
  const { grp, sheet, workId } = useParams();
  const navigat = useNavigate();
  const http = httpConfig();
  const [sheetDetail, setSheetDetail] = useState([]);
  const [dataStudent, setDataStudent] = useState([]);

  const [scorePoint, setScorePoint] = useState([]);

  const advisorData = JSON.parse(localStorage.getItem("advisor"));

  const filterWorklocalStorage = localStorage.getItem("filterWork")
    ? JSON.parse(localStorage.getItem("filterWork"))
    : "";

  const statusDone = localStorage.getItem("done")
    ? JSON.parse(localStorage.getItem("done"))
    : "";
  const [statusWork, setStatusWork] = useState(false);

  const [listHighlight, setListHighlight] = useState(() => {
    let data = localStorage.getItem("highlight")
      ? JSON.parse(localStorage.getItem("highlight"))
      : "";
    let arr = [];
    if (data[0]) {
      data.map((res) => {
        if (res.sheetId.toString() === sheet.toString()) {
          arr.push(res);
        }
      });
    }

    return arr;
  });

  // CheckingLogin().then((res) => {
  //   if (!res) {
  //     console.log("ต้องออกจากระบบ");
  //     Swal.fire({
  //       icon: "error",
  //       title: "!!เข้าสู่ระบบล้มเหลว!!",
  //       text: "กรุณาลองเข้าสู่ระบบอีกครั้ง",
  //       showConfirmButton: false,
  //       timer: 1400,
  //     });
  //     setTimeout(() => {
  //       window.location.href = "/estimate";
  //     }, 1400);
  //   }
  // });
  ProtectedLogin(2);

  function fetchStudentGroup() {
    // console.log(advisorData.advisor_id, grp);

    let requestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        group: grp,
        // id: advisorData.advisor_id,
      }),
    };

    let bodyrequest = {
      group: grp,
    };

    fetch(
      `${http}/studentINgroup`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        // console.log("dataDetail=>", data);
        // console.log("highlightDetail=>", listHighlight);
        let arr = [];
        data.map((Dstudent) => {
          listHighlight.map((ele) => {
            if (ele.workId.toString() === workId.toString()) {
              if (ele.sheetId.toString() === sheet.toString()) {
                if (ele.studentID.trim() === Dstudent.studentID.trim()) {
                  arr.push(Dstudent);
                }
              }
            }
          });
        });
        // console.log("ดูอันนี้ก่อน>", arr);
        setDataStudent(arr);
      })
    );
  }

  function fetchSheetDetail() {
    // console.log("???=>", grp, sheet, workId);
    let requestOption = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ id: sheet }),
    };

    let bodyrequest = {
      id: sheet,
    };
    fetch(`${http}/sheet`, RequestFetch("POST", bodyrequest, usertoken)).then(
      (res) =>
        res.json().then((data) => {
          // console.log(data);
          setSheetDetail(data);
        })
    );
  }

  const scoreArr = [];
  async function fetchScore(studentId, workId, index, lenghtdata) {
    let resultArr = [];
    let bodyrequest = {
      IdStudent: studentId,
      Idwork: workId,
    };

    await fetch(
      `${http}/WorkDetailScore`,
      RequestFetch("POST", bodyrequest, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        if (!data[0]) {
          scoreArr.push({ studentId: studentId, point: "" });
          return console.log("มีหลุด", studentId);
        }
        if (data[0]) {
          // console.log("this data have point ", data);
          let stID,
            num = 0,
            object = {};
          data.map((data, index) => {
            stID = data.studentID;
            num = num + data.score;
          });
          object = { studentId: stID, point: num };
          // console.log("คะแนนของ", stID, "ได้", object);
          resultArr.push(object);
          scoreArr.push(object);
        }
      })
    );
    if (scoreArr.length === lenghtdata) {
      console.log("ถ้าแบบนี้", scoreArr);
      setScorePoint(scoreArr);
    }
  }

  function handleShowScore(data, Id) {
    // console.log("ข้อมูลที่จะมาแสดง", data);
    if (!data[0]) return;
    if (data[0]) {
      let result;
      data.map((ele) => {
        if (ele.studentId === Id) {
          result = ele.point;
        }
      });
      return result;
    }
  }

  // ทำการลบเช็คค่าจาก hightlight
  function handleCheckDash(idStudent, group, Id) {
    let dataArr = [];
    let dataSet = [];

    // console.log("ข้อมูลตัด workDetail", workId, Id, advisorData.advisor_id);
    fetchDashWorkdetail(workId, Id, advisorData.advisor_id);

    let thisHighlight = JSON.parse(localStorage.getItem("highlight"));
    console.log("highlight >", thisHighlight);
    thisHighlight.map((hlDB) => {
      // console.log(hlDB.sheetId);
      if (hlDB.workId.toString() === workId.toString()) {
        if (hlDB.sheetId.toString() === sheet.toString()) {
          if (hlDB.group.toString() === group.toString()) {
            if (hlDB.studentID.trim() !== idStudent.trim()) {
              dataArr.push(hlDB);
            }
          }
        }
      } else {
        dataArr.push(hlDB);
      }
    });

    console.log("highlight ที่ตัดมาแล้วเหลือตะอี้", dataArr);

    if (!dataArr[0]) {
      navigat(
        `/grouplist/${grp}/${sheet}/${workId}?timestamp=${new Date().getTime()}`
      );
    }

    if (dataArr[0]) {
      let thisBack = true;

      dataArr.map((ele) => {
        if (ele.workId.toString() === workId.toString()) {
          // console.log("มันตรงนะยังไม่ต้องกลับไป");
          thisBack = false;
        }
      });

      if (thisBack) {
        navigat(
          `/grouplist/${grp}/${sheet}/${workId}?timestamp=${new Date().getTime()}`
        );
      }
    }

    localStorage.setItem("highlight", JSON.stringify(dataArr));

    //เปลี่ยน dataSet เป็น dataArr
    setListHighlight(dataArr);
  }

  async function checkAssageMentStudent(IdStudent, sheetId, workid) {
    let requestCheckAssessment = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        IdSdt: IdStudent,
        Idsheet: sheetId,
      }),
    };
    let bodycheckass = {
      IdSdt: IdStudent,
      Idsheet: sheetId,
      workID: workid,
    };

    fetch(
      `${http}/checkassessmentstudent`,
      RequestFetch("POST", bodycheckass, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        if (data[0]) {
          let divCardStudent = document.getElementById(
            `cardStudent-${data[0].student_id}`
          );
        }
      })
    );
  }

  // ลบ workDetail
  function fetchDashWorkdetail(wkID, stID, advID) {
    //stID = ไอดีลำดับของนักเรียนในดาต้า
    // let requestCheck = {
    //   method: "POST",
    //   headers: { "content-type": "application/json" },
    //   body: JSON.stringify({
    //     idwork: wkID,
    //   }),
    // };

    // let requestOption = {
    //   method: "DELETE",
    //   headers: { "content-type": "application/json" },
    //   body: JSON.stringify({
    //     workID: wkID,
    //     studentID: stID,
    //     advisorID: advID,
    //   }),
    // };

    let bodyCheckass = {
      idwork: wkID,
    };
    let bodydashoff = {
      workID: wkID,
      studentID: stID,
      advisorID: advID,
    };

    fetch(
      `${http}/workDetailCheckAssessment`,
      RequestFetch("POST", bodyCheckass, usertoken)
    ).then((res) =>
      res.json().then((data) => {
        //ดึงไฮไลน์
        let localHighlight = localStorage.getItem("highlight")
          ? JSON.parse(localStorage.getItem("highlight"))
          : "";
        console.log("stID คือ >", stID);
        console.log("workDetailcheckass >>", data);
        data.map((ele) => {
          if (!ele.score) {
            if (ele.student_id === stID) {
              console.log("ลบเลยอ้ายบ่าว", wkID, stID, advID);
              // ลบออกไป
              fetch(
                `${http}/dashOffWorkdetail`,
                RequestFetch("DELETE", bodydashoff, usertoken)
              ).then((res) =>
                res.json().then((message) => {
                  console.log(message);
                })
              );
            }
          }
        });
      })
    );
  }

  useEffect(() => {
    if (statusDone[0]) {
      statusDone.map((data) => {
        if (workId.toString() === data.wkID) {
          setStatusWork(true);
          document.getElementById("NavHightlight").style.backgroundColor =
            "#33691e";
        }
      });
    }
  }, [statusDone]);

  useEffect(() => {
    // console.log("this only hight->", listHighlight);
    fetchSheetDetail();
    fetchStudentGroup();
  }, [listHighlight]);

  useEffect(() => {
    if (!dataStudent[0]) return;
    // console.log("เช็คค่า AssagementStucent ใหม่", dataStudent);
    dataStudent.map(async (data, index) => {
      checkAssageMentStudent(data.Id, sheet, workId);
      fetchScore(data.Id, workId, index, dataStudent.length);
    });
  }, [dataStudent]);

  useEffect(() => {
    Addmetatags();
    if (!grp || grp === "null") {
      Swal.fire({
        icon: "error",
        title: "!!ไม่มีกลุ่มนักศึกษาที่จะทำการประเมินในครั้งนี้!!",
        text: "กรุณาตรวจสอบข้อมูลกลุ่มนักศึกษา",
        showConfirmButton: false,
        timer: 1800,
      });
      navigat(`/listWork?timestamp=${new Date().getTime()}`);
    }
    if (!usertoken) {
      Swal.fire({
        icon: "error",
        title: "!!เข้าสู่ระบบล้มเหลว!!",
        text: "กรุณาลองเข้าสู่ระบบอีกครั้ง",
        showConfirmButton: false,
        timer: 1400,
      });
      setTimeout(() => {
        window.location.href = "/estimate";
        cookie.remove("tokenEstimate");
      }, 1400);
    }
  }, []);

  // console.log(sheetDetail[0] ? sheetDetail[0].name.trim().split(" ") : "");

  return (
    <div className="listStudent-page">
      <div className="nav-wardround-student-highlight" id="NavHightlight">
        <div className="box-relative-nav">
          <i
            className="icon-footer-nav bi-chevron-left"
            style={statusWork ? { display: "none" } : { display: "block" }}
            onClick={() => {
              navigat(
                `/grouplist/${grp}/${sheet}/${workId}?timestamp=${new Date().getTime()}`
              );
              // localStorage.removeItem("highlight");
            }}
          ></i>
        </div>
        <div className="box-title-nav">
          <span>
            {sheetDetail[0] ? sheetDetail[0].name.trim().split(" ")[0] : ""}
            &nbsp;
            {sheetDetail[0] ? sheetDetail[0].name.trim().split(" ")[1] : ""}
          </span>
        </div>
        <div className="box-relative-nav">
          <i
            className="icon-footer-nav bi-x"
            style={{ fontSize: "26px" }}
            onClick={() => {
              navigat(`/listWork?timestamp=${new Date().getTime()}`);
            }}
          ></i>
        </div>
      </div>
      <div className="content-wardround-list-highlight">
        {scorePoint[0] ? (
          dataStudent[0] ? (
            dataStudent.map((data, id) => (
              <div className="card-box" id={`cardStudent-${data.Id}`} key={id}>
                <div className="img-list-wardround">
                  <img
                    className="img-student-omg"
                    // src={`${http}/viewImage/${data.studentID.trim()}.jpg`}

                    src={showURL(data.studentID)}
                    // src={`https://datasoft.co.th/estimate/image/student/${
                    //   filterWorklocalStorage
                    //     ? filterWorklocalStorage.ayear
                    //     : moment(new Date()).format("YYYY")
                    // }/${data.studentID.trim()}.jpg`}
                    id={`img-list-${data.studentID.trim()}`}
                    width={50}
                    height={50}
                    onClick={() => {
                      navigat(
                        `/assessment/${
                          data.studentID
                        }/${grp}/${sheet}/${workId}?timestamp=${new Date().getTime()}`
                      );
                    }}
                  ></img>
                </div>
                <div
                  className="info-img-list-wardround"
                  id={`name-listInfo-${data.studentID.trim()}`}
                  onClick={() => {
                    navigat(
                      `/assessment/${
                        data.studentID
                      }/${grp}/${sheet}/${workId}?timestamp=${new Date().getTime()}`
                    );
                  }}
                >
                  <p className="nameStudent">{`${data.studentname.trim()}  ${
                    data.studentlname
                  }`}</p>
                </div>
                <div className="show-score">
                  {/* คะแนน */}
                  <p>{handleShowScore(scorePoint, data.Id)}</p>
                </div>
                <div className="btn-choose-highlight">
                  <i
                    className="bi-dash-circle i-icon-highlightDash"
                    id={`icon-dash-${data.studentID.trim()}`}
                    onClick={() => {
                      //data.Id = student_id
                      console.log(data.studentID, grp, data.Id);
                      handleCheckDash(data.studentID, grp, data.Id);
                    }}
                  ></i>
                </div>
              </div>
            ))
          ) : (
            <div className="loading-box">
              <div className="just-loading-page">
                <div className="loader"></div>
                <span>{`Loading...`}</span>
              </div>
            </div>
          )
        ) : (
          <div className="loading-box">
            <div className="just-loading-page">
              <div className="loader"></div>
              <span>{`Loading...`}</span>
            </div>
          </div>
        )}
      </div>
      {/* <div className="footer-nav-btn"></div> */}
    </div>
  );
};
export default ListStudentHL;
